import clsx from 'clsx';
import {
  HTMLAttributes,
  MouseEvent,
  MouseEventHandler,
  ReactNode,
} from 'react';
import styles from './WebChat.module.scss';
import { Button, IconButton } from '@trg/tlw-ui-component';
import { X } from '@trg/icon/tlw';

interface WebChatProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'> {
  show?: boolean;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement> &
    MouseEventHandler<HTMLAnchorElement>;
}

export function WebChat({
  show = false,
  className,
  children,
  onClick,
  ...props
}: WebChatProps) {
  return (
    <div
      className={clsx(
        styles['container'],
        show ? 'tlw-block' : 'tlw-hidden',
        className
      )}
      {...props}
    >
      <div className={styles['header']}>
        {onClick && (
          <button className={styles['close']} onClick={onClick}>
            <X />
          </button>
        )}
        <h4 className={styles['header-title']}>數位客服</h4>
      </div>
      <div className={styles['chat']}>{children}</div>
    </div>
  );
}
